export default __webpack_public_path__ + "static/media/aeroland-branding-image-laptop.5987ff29.png";